import EmployerBankDetailsPage from './EmployerBankDetailsPage';
export default EmployerBankDetailsPage;